import { Button } from "@/components/ui/button";

const InquiryCtaSection = ({ onOpenInquiry }) => (
  <section className="py-16 md:py-20">
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center rounded-[18px] gold-gradient-surface py-14 px-6 md:px-16 relative overflow-hidden">
      <h2 className="font-[var(--font-serif)] text-2xl md:text-3xl font-semibold text-[color:var(--brand-charcoal)]">
        Bizimle Çalışmak İster Misiniz?
      </h2>
      <p className="text-sm md:text-base text-[color:var(--brand-charcoal)]/80 mt-3 max-w-xl mx-auto leading-relaxed">
        İster bir mülk arıyor olun, ister portföyünüzü değerlendirmek isteyin; danışmanlarımız sizinle iletişime
        geçmek için hazır.
      </p>
      <Button
        data-testid="home-cta-open-inquiry"
        onClick={onOpenInquiry}
        className="mt-6 h-12 px-8 rounded-[12px] bg-[color:var(--brand-charcoal)] text-[color:var(--brand-cream)] font-medium hover:opacity-90 transition-opacity"
      >
        Talep Oluştur
      </Button>
    </div>
  </section>
);

export default InquiryCtaSection;
